/**
 * Google Sign-In client IDs for the NATIVE (bundled Capacitor) sign-in path.
 *
 * These are the per-platform OAuth clients created in Google Cloud project
 * `tradeloop-502516` (card D). Full provenance — including why there are two
 * Android clients that appear nowhere in this file — is in
 * `src/docs/GOOGLE_OAUTH_SETUP.md` §8.2 / §8.8.
 *
 * Client IDs are **not secrets** (they ship inside the app binary), but they are
 * environment-shaped, so each one can be overridden at build time. The defaults
 * are the real production values so a build with no extra env configuration —
 * which is what the mobile release workflow does today — still works.
 *
 * The web flow does NOT use any of these: it goes through Supabase's
 * `/auth/v1/authorize`, and Supabase holds the web client ID + secret itself.
 */
export const GOOGLE_CLIENT_IDS = {
  /**
   * The **web** OAuth client. On Android this is the `serverClientId` Credential
   * Manager mints against, so it is also the `aud` of every Android id_token.
   * Passing an *Android* client ID here is the classic failure (§8.5).
   */
  web:
    (import.meta.env.VITE_GOOGLE_WEB_CLIENT_ID as string | undefined) ||
    '296902586033-bd47etuu1uop07k9lo2v35hqcceloiin.apps.googleusercontent.com',

  /** The iOS OAuth client — bundle `com.gotradeloop.mobile`, and the `aud` of every iOS id_token. */
  ios:
    (import.meta.env.VITE_GOOGLE_IOS_CLIENT_ID as string | undefined) ||
    '296902586033-jivfqn4ip5f3vqt3vdi3rlp40n6i24ha.apps.googleusercontent.com',
} as const;
